<template>
  <div>
    <d-dropdown
      :theme="theme"
      :size="size"
      :noCaret="noCaret"
      ref="dropdown"
      :toggleClass="[
        'd-flex align-items-center',
        highlight ? highlightClass : ''
      ]"
    >
      <template v-slot:button-content class="d-fle">
        <i v-if="icon" class="material-icons" style="margin-right: 4px;">
          {{ icon }}
        </i>
        <span>
          {{ text }}
        </span>
      </template>
      <d-dropdown-check
        v-for="(item, index) in items"
        :key="`${text}__${index}`"
        :value="isChecked(item.name)"
        :slug="item.name"
        @change="onChange"
      >
        {{ item.title || item.name.replace(/[a-z]/i, t => t.toUpperCase()) }}
      </d-dropdown-check>
    </d-dropdown>
  </div>
</template>

<script>
export default {
  name: "dd-check-list",
  props: {
    value: {
      default: ""
    },
    name: {
      default: null
    },
    text: {
      type: String
    },
    icon: {
      type: String
    },
    items: {
      type: Array
    },
    radio: {
      type: Boolean,
      default: false
    },
    noCaret: {
      default: true
    },
    theme: {
      default: "clear"
    },
    size: {
      default: "sm"
    },
    highlightClass: {
      type: String,
      default: null
    }
  },
  watch: {
    value: {
      deep: true,
      handler() {
        return
      }
    }
  },
  methods: {
    isChecked(slug) {
      return this.radio ? this.value === slug : this.value.includes(slug);
    },
    onChange(e) {
      let newValue = null;
      if (this.radio) {
        newValue = e.slug;
        this.$refs.dropdown.away();
      } else {
        if (e.value) {
          // Remove value
          newValue = this.value.filter(item => item !== e.slug);
        } else {
          // Add value
          newValue = [...this.value, e.slug];
        }
      }

      this.$emit("input", newValue);
      this.$emit("change", { value: newValue, name: this.name });
    }
  },
  computed: {
    highlight() {
      return this.value !== "";
    }
  }
};
</script>
